import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=24042c7c&scoped=true&"
import script from "./problem.vue?vue&type=script&lang=js&"
export * from "./problem.vue?vue&type=script&lang=js&"
import style0 from "./problem.vue?vue&type=style&index=0&id=24042c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24042c7c",
  null
  
)

export default component.exports